<template>
  <div class="inputs-wrapper">
    <basic-input
      v-model="name"
      type="text"
      label="Hour type name"
      :setFocus="true"
      @keyup.enter="saveChanges"
    />
  </div>
  <div class="inputs-wrapper">
    <basic-button label="Save changes" @click="saveChanges" />
  </div>
</template>
<script setup lang="ts">
import { ModalStore } from "../../store/modalStore";
import api from "@/api";
import { openCustomToast } from "@/assets/js/helpers";
import { CompanyStore } from "@/store/companyStore";

const modalStore = ModalStore();
const companyStore = CompanyStore();
const name = ref<string | null>(null);
const props = defineProps(["options"]);
defineEmits(["close"]);

const oldName = ref<string | null>(null);

onMounted(() => {
  oldName.value = props.options.data.tst_name;
  name.value = props.options.data.tst_name;
});

async function saveChanges() {
  if (!name.value) {
    openCustomToast("The 'Hour type name' field is required", "error");
    return;
  }
  if (name.value === oldName.value) {
    openCustomToast("The field 'Hour type name' has not been changed", "error");
    return;
  }
  const params: any = {
    tst_name: name.value,
    tst_id: props.options.data.tst_id,
    cmp_id: companyStore.getActiveCompany?.cmp_id,
  };
  try {
    await api.editHourType(params.tst_id, params);
    openCustomToast("You have successfully changed the hour type", "success");
    if (props.options.update) {
      props.options.update();
    }
    modalStore.setModalData(null);
  } catch (error: any) {
    openCustomToast("An error occurred while changing the hour type", "error");
  }
}
</script>
<style lang="scss" scoped>
.inputs-wrapper {
  margin-bottom: 15px;
}
</style>
